import { GetServerSideProps, NextComponentType } from 'next'
import { NFTCatalogDoc, NFTTokenDoc } from 'interfaces'
import ErrorNotFound from 'components/CustomError/ErrorNotFound'
import ErrorInternalServer from 'components/CustomError/ErrorInternalServer'
import NFTDetail from 'components/NFTDetail/NFTDetail'
import PanNumberProvider from 'contexts/PanNumberProvider'
import XpProvider from 'contexts/XpProvider'
import { getSearchObjectsById } from 'utils/searchUtil'

const NFTListingDetailWithToken: NextComponentType<
  {},
  {},
  {
    errorCode: number
    catalogDoc: NFTCatalogDoc
    tokenDoc: NFTTokenDoc
  }
> = ({ errorCode, catalogDoc, tokenDoc }) => {
  if (errorCode === 404) {
    return <ErrorNotFound />
  }
  if (errorCode === 500) {
    return <ErrorInternalServer />
  }
  return (
    <PanNumberProvider>
      <XpProvider>
        <NFTDetail catalogDoc={catalogDoc} tokenDoc={tokenDoc} />
      </XpProvider>
    </PanNumberProvider>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const { catalogId, tokenId } = query
  const { SEARCH_INDEX_NAME = '', USER_VAULT_INDEX_NAME = '' } = process.env
  try {
    const [catalogDoc, tokenDoc] = await getSearchObjectsById([
      { index: SEARCH_INDEX_NAME, id: catalogId as string },
      { index: USER_VAULT_INDEX_NAME, id: tokenId as string },
    ])
    // @ts-ignore
    if (catalogDoc?.objectID.toString() === (tokenDoc?.catalog_id as string).toString()) {
      return {
        props: {
          catalogDoc,
          tokenDoc,
        },
      }
    } else {
      return {
        props: {
          errorCode: 404,
        },
      }
    }
  } catch (e) {
    return {
      props: {
        errorCode: 404,
      },
    }
  }
}

export default NFTListingDetailWithToken
